const s = ["xs", "sm", "md", "lg"], m = "md";
export {
  m as DEFAULT_SIZE,
  s as sizes
};
